export default {
    "pages.account.info": 'Account Information',
    "pages.welcome.title": "Welcome to INTER SKY PROFIT LIMITED",
    "pages.certification.title": "Professional Certification",
    "pages.certification.description": "Multiple international certifications, quality assurance",
    "pages.support.title": "Technical Support",
    "pages.support.description": "24/7 around-the-clock technical support",
    "pages.global_service.title": "Global Service",
    "pages.global_service.description": "Covering major markets in the Asia-Pacific region",
    "pages.feature.learn_more": "Learn More",
    "pages.contact.title": "Contact Us",
    "pages.contact.company_address": "Company Address",
    "pages.contact.business_hours": "Business Hours",
    "pages.contact.email": "Email",
    "pages.contact.phone": "Contact Phone",
    "pages.contact.address": "Unit A,3/F Cheong Sun Tower116-118 Wing Lok Street, Sheung Wan, HK",
    "pages.contact.hours": "Monday to Friday: 9:00 - 18:00",
    "pages.welcome.alertMessage": "New heavy-duty components are now faster and stronger.",
    "pages.welcome.description": "We focus on the production and distribution of renewable energy products, providing wholesale EV charging station sales and comprehensive energy system construction and maintenance services.",
    "pages.admin.subPage.title": "Access restricted: Admins only.",
    "pages.notFind.description": "No data available. Please check your request.",
    "pages.404.subTitle": "Page not found",
    "pages.404.buttonText": "Back",

    "user.auth.username": "username",
    "user.auth.pwd": "Password",
    "user.auth.confirmed_pwd": "Password Confirmation",
    "user.auth.forgotten_pwd": "Forgotten Password",
    "user.auth.username.alert": "Please input your username！",
    "user.auth.pwd.alert": "Please input your password!",
    "user.auth.error_message": "Invalid account or password",
    "user.auth.error": "Login Failed",
    "user.auth.success": "Login Succcess",
    "user.auth.remember_me": "Remember Me",
    "user.auth.email_format": "Invalid email format",
    "user.auth.forgotten_sent_success": ": Forgotten password request sent successfully",
    "user.auth.captcha": "CAPTCHA",
    "user.auth.fetch_captcha": "Fetch CAPTCHA",
    "user.auth.captcha_retry": "Retry in",
    "user.auth.captcha_sec": "Seconds",
    "user.auth.captcha_empty": "The CAPTCHA field cannot be empty.",
    "user.auth.reset.unmatch_confirmed_pwd": "Passwords do not match.",
    "user.auth.reset.pwd_rule": "Password must be at least 8 characters long and include at least one letter and one non-letter character.",
    "user.auth.reset.pwd_placeholder": "Enter and confirm your new password.",
    "user.auth.reset.pwd": "New password",
    "user.setting": "User Settings",
    "user.logout": "Logout",
    "user.uid": "Id",
    "user.email": "Email",
    "user.tel": "Telephone",
    "user.nickname": "Nick Name",
    "user.admin": "Admin",
    "user.admin_true": "Yes",
    "user.admin_false": "False",
    "user.account_status": "Account Status",
    "user.account_status_active": 'Active',
    "user.account_status_locked": 'Locked',
    "user.account_status_suspended": 'Suspended',
    "user.lock_date": "Lock Date",
    "user.deleted_at": "deleted_at",
    "user.account.avatar": "Avatar",

    "del_acc.title": "Delete Thunder Power Account",
    "del_acc.parapgrah1": "Before proceeding with the deletion of your account, it is imperative that you understand this action is irreversible.",
    "del_acc.parapgrah2": "Confirming the deletion signifies your acknowledgment that you will be permanently unable to retrieve your account and all associated information and record history. This includes personal data, service usage records, transaction details, and any content created or shared.",
    "del_acc.parapgrah3": "If you wish to save any data, please ensure you back it up before initiating the deletion process. Once your account is deleted, recovery will not be possible. Additionally, any remaining balance in your account will be returned to you via check. To facilitate this process, you must provide your information to ensure proper handling of your balance refund.",
    "del_acc.parapgrah4": "Once you submit a request for account deletion, your account will be closed immediately. Please note that processing any remaining balance refund may take up to 180 working days.",
    "del_acc.parapgrah5": "For any concerns or assistance, please contact our team for more information.",
    "del_acc.btn": "Delete Account",
    "del_acc.confirmation": "I acknowledge that deleting my account is a permanent action and cannot be undone. I agree to the terms outlined above.",
    "del_acc.req": "You must confirm your acknowledgment to proceed.",
    "del_acc.refund_address": "Hong Kong mailing address (required for balance refund by check).",
    "del_acc.payee_name": "Payee Name",
    "del_acc.refund_address_table": "Refund Address",
    "del_acc.remark": "Remark(s)",
    "del_account_status.pending": "Pending",
    "del_account_status.processing": "Processing",
    "del_account_status.completed": "Completed",
    "del_account_confirm_message": "Are you sure you want to delete your account? Once confirmed, you will no longer be able to use our service.",
    "del_account_process_message": "We have received your request and have begun processing your unsubscription. Additionally, you will no longer be able to use our service. Your account balance will be refunded to you via cheque within 7–14 working days."
}